import { VITE_ONBOARDING_MINIMAL } from 'src/constants/envs';
import { eOnboardingStep } from './Onboarding.enum';

// Character caps for onboarding long-text fields (RET-839).
// Aligned with the BFF contract.
export const MAX_BUSINESS_DESCRIPTION = 30000;
export const MAX_SALES_PROCESS_TEXT = 35000;

// Extracted from inline literals in FunnelSetup.component.tsx (RET-839).
export const MAX_STAGE_NAME = 100;
export const MAX_STAGE_DESCRIPTION = 300;

// ── Active onboarding flow (single source of truth) ──────────────────────────
// The ordered list of steps the user actually walks. Every consumer (the hook's
// next/prev/validation, ProgressChecklist, ActiveStepContent's terminal-step
// wiring, the DEV navigator) reads this so the flow can be reshaped in one place.
//
// RET-1387: when VITE_ONBOARDING_MINIMAL is on, the Lead Agent config and Team
// Invite steps are dropped — WhatsAppConnect becomes terminal and completion
// redirects to /pipe (where lead-profiling runs). Gated so prod keeps the full
// flow until the profiling pipeline works end-to-end.
const FULL_STEPS: eOnboardingStep[] = [
  eOnboardingStep.BUSINESS_INFO,
  eOnboardingStep.FUNNEL_SETUP,
  eOnboardingStep.WHATSAPP_CONNECT,
  eOnboardingStep.SMART_LEADBOT,
  eOnboardingStep.TEAM_INVITE,
];

// AGI-383: the post-payment wizard no longer collects Lead Agent context.
// "Tu negocio" (company lookup + business description) and "Tu embudo"
// (generateFunnel + the onboarding funnel upsert) are dropped from the flow —
// that context is now asked for when the Lead Agent add-on is activated, and
// funnel stages come from the signup templates (AGI-409). What remains is the
// single action that produces the aha moment: connecting WhatsApp.
//
// The step components stay in the tree, wired and tested, so a flag flip or a
// future re-introduction costs an array entry. Nothing below is deleted.
const MINIMAL_STEPS: eOnboardingStep[] = [eOnboardingStep.WHATSAPP_CONNECT];

export const ONBOARDING_STEPS: eOnboardingStep[] = VITE_ONBOARDING_MINIMAL
  ? MINIMAL_STEPS
  : FULL_STEPS;

// The step that finishes onboarding (its completion redirects to /pipe).
export const ONBOARDING_TERMINAL_STEP =
  ONBOARDING_STEPS[ONBOARDING_STEPS.length - 1];
